<pbc-placeholder></pbc-placeholder>
<div *ngIf="data?.isVisible" [ngClass]="data?.content?.parentClasses" [innerHtml]="data?.content?.html | safehtml" data-id="html-block">
</div>

